import React, { Component } from 'react';
import LoadingSpinner from './common/LoadingSpinner';
import Login from './Login/Login';
import Dashboard from './Dashboard';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      authenticated: false,
    }
  }

  componentDidMount = () => {
    Promise.all([this.authenticateUser()])
    .then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  authenticateUser = () => {
    return fetch(
      '/api/authenticateUser',
      {
        method: "GET",
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (res.ok) {
        this.setState({
          authenticated: true,
        });
      }
    })
    .catch(error => console.log(error));
  }

  login = (username) => {
    localStorage.setItem("username", username);
    let urlParams = new URLSearchParams(this.props.location.search);
    let redirectUrl = urlParams.get('redirect');
    if (redirectUrl === null) {
      this.setState({ authenticated: true });
    } else {
      window.location.href = 'https://' + redirectUrl;
    }
  }

  logout = () => {
    fetch(
      '/api/logout',
      {
        method: "GET",
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText);
      } else {
        localStorage.setItem("username", null);
        if (window.location.search !== '') {
          window.location.href = '/';
        }
        this.setState({ authenticated: false });
      }
    })
    .catch(error => console.log(error));
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    if (this.state.authenticated) {
      return <Dashboard logout={this.logout} />;
    }

    return <Login login={this.login} />;
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/Components/App.js